'use client';

import styled from 'styled-components';

import { getLabelTypography } from '@components/Common/Label';

export const ToastMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ToastLabel = styled.label`
  ${getLabelTypography}
`;
